import api from "./api";

let parseImdbResponse = (r, isMovie) => {
    
    // d object
    var d=  r.d;
    // filter out only "features"
    var out = [];
    d.forEach(x => {
        if (isMovie && x.q=="feature") {
            out.push({
                title: x.l,
                id: x.id,
                starring: x.s,
                year: x.y,
            })
        }
        if (!isMovie && ( x.q == "TV mini-series" || x.q == "TV series")) {
            out.push({
                title: x.l,
                id: x.id,
                starring: x.s,
                years: x.yr,
            })
        }
    });
    return out;
    
    
}


let TmdbQuery = (imdbId) => {
    return api.vision.getTmdb(imdbId);
}

export default {
    parseImdbResponse,
    TmdbQuery
}